const Theme = {
  logo_image_url: 'chateaudufresne.jpg',
  logo_height: 120,

  header_background_color: '#77787B',

  number_hidden: true,
  token_hidden: true,

  button_color: '#77787B',
  button_radius: 50,

  button_half_font: `'Open Sans', sans-serif`,
  button_half_text_weight: 600,
  button_half_border_color: 'transparent',
  button_half_text_color: '#77787B',
  button_half_text_size: 13,

  text_font: `'Arial', sans-serif`,

  title_font: `'Arial', sans-serif`,

  footer_border_color: '#eee',

  separator_color: '#C0C2C3',
  separator_height: 3,
  separator_radius: 10,
}

export default Theme
